import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { LoadingScreen } from '../components/ui/LoadingScreen'
import { can } from '../lib/permissions'

type ProtectedRouteProps = {
  permission?: string
}

export function ProtectedRoute({ permission }: ProtectedRouteProps) {
  const { phase, me } = useAuth()
  const location = useLocation()

  if (phase === 'loading') {
    return (
      <LoadingScreen
        message="読み込み中…"
        className="loading-screen--fade-in"
      />
    )
  }

  if (phase === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (phase === 'needs_invite') {
    return <Navigate to="/invite-required" replace />
  }

  if (phase === 'email_required' || phase === 'error') {
    return <Navigate to="/error" replace />
  }

  if (permission && !can(me?.permissions ?? [], permission)) {
    return <Navigate to="/forbidden" replace />
  }

  return <Outlet />
}
